import PersonIcon from '@material-ui/icons/Person';
import UserList from './UserList';

export default {
    icon: PersonIcon,
    list: UserList,
};
